import FormValidation from '@/js/components/forms/formValidation';

class EstateDetailEnhancedReport {
  constructor() {
    this.dom = {
      formReport: document.getElementById('form-account-report-update'),
      formRegister: document.getElementById('form-report-to-account'),
    };

    this.components = {
      reportFormValidation: null,
      accountFormValidation: null,
    };
  }

  mount() {
    if (this.dom.formReport) {
      this.components.reportFormValidation = new FormValidation(this.dom.formReport);
    }
    if (this.dom.formRegister) {
      this.components.accountFormValidation = new FormValidation(this.dom.formRegister);
    }
  }
}

if (document.getElementById('page-estates-detail-enhanced-report')) {
  new EstateDetailEnhancedReport().mount();
}
